import { useCallback, useSyncExternalStore } from "react";

import type { Assignment } from "../SettingsPayload";
import { generationSettingStore } from "../store/SettingsGenerationSettingStore";

/** 1 件の生成担当を購読する。下書き中は undefined。 */
export function useAssignment(id: string): Assignment | undefined {
    const subscribe = useCallback(
        (cb: () => void) => generationSettingStore.subscribeAssignment(id, cb),
        [id]
    );
    const getSnapshot = useCallback(() => generationSettingStore.getAssignment(id), [id]);
    return useSyncExternalStore(subscribe, getSnapshot);
}
